/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import { withFallback } from "kontrolEdge/helpers/formattersShappedData";

export type ConnectionRef = {
    id: string;
    subscriptionId: string;
    //NEW
    connectedServiceId?: number | string;
    connectedServiceType?: string;           
    connectedServiceSubId?: string;
  };
export interface Quotation {
    id: number;
    serviceId: string;
    name: string;
    tag: string[];
    customer?: {
        name: string
        id: number;
        chargebeeCustomerId: string
    }
    status: string;
    type?: string;
    createdAt?: string;
}

export const fwaasColumns: GenericTableColumn<Quotation>[] = [
    {
        header: "Quotation ID",
        accessor: "serviceId",
        renderCell: (row) => <div>{row.serviceId}</div>,
        // renderCell: (row) => <div>{row.name}</div>,
    },
    {
        header: "Status",
        renderCell: row => {
            const status = row.status;
            let variant: "success"|"default"|"error"|"warning";
            let label: string;
        
            if (status === "up") {
            variant = "success";
            label = "Active";
        } else if (status === undefined || status === null) {
            variant = "default";
            label = "Unknown";
        } else if (status === "down") {
            variant = "error";
            label = "Down";
        } else {
            variant = "warning";
            label = "Unknown";
        }
        return <GenericTag variant={variant} label={label} size="small"/>;
        },		
    },
    {
      header: "Creation Date",
      accessor: "createdAt",
    },
    {
      header: "Details",
  
      accessor: "name",
      renderCell: (row) => (
        <div>
          {/* View Button */}
          <button
            className="
              px-3 py-1
              border border-semantic-border-secondary
              rounded
              text-semantic-text-secondary
              hover:bg-semantic-state-active
            "
            onClick={() => {
              console.log("View port detail:", row);
            }}
          >
            View
          </button>
        </div>
      ),
    },
];

const toConnArr = (x: unknown): ConnectionRef[] => {
  if (Array.isArray(x)) {
    return x.map((v: any) => {
      if (v && typeof v === "object") {
        const id = String(v.id ?? v.subscriptionId ?? "");
        const subscriptionId = String(v.subscriptionId ?? v.id ?? id);

        const cs = v.connectedService ?? {};
        const connectedServiceId =
          cs.id ?? v.connectedServiceId ?? undefined;
        const connectedServiceType =
          cs.type ?? v.connectedServiceType ?? undefined;
        const connectedServiceSubId =
          cs.subscriptionId ?? cs.name ?? v.connectedServiceSubId ?? undefined;

        return {
          id,
          subscriptionId,
          connectedServiceId,
          connectedServiceType,
          connectedServiceSubId,
        };
      }
      const s = String(v ?? "");
      return { id: s, subscriptionId: s };
    });
  }
  if (x == null) return [];
  const s = String(x);
  return [{ id: s, subscriptionId: s }];
};


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const shapeFwaasData = (fwaas: any[]): Quotation[] => {
    return fwaas.map((p) => {
        const customer = p.customer
        ? {
            name: p.customer.name ?? "-",
            id: p.customer.id ?? "-",
            chargebeeCustomerId: p.customer.chargebeeCustomerId ?? "-"
            }
        : undefined;

        const internet = toConnArr(p.connections?.internet);
        const cloudConnectivity = toConnArr(p.connections?.cloudConnectivity);
        const fwint = toConnArr(p.connections?.fwint);
        const port = toConnArr(p.connections?.port);
        const datacenter = toConnArr(p.connections?.datacenter);

        const buckets = { internet, cloudConnectivity, fwint, port, datacenter };
        const visibleId = withFallback(p.name);

    return {
        id: p.id,
        serviceId: visibleId, 
        name: visibleId,
        customer,
        status: withFallback(p.status),
        tag: Array.isArray(p.tag) ? p.tag : [withFallback(p.tag)],
    }});
  };

